import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  apiAccessToken: null,
  baseURL: null,
  brand: null,
  enablePay360CardPayments: true,
  environment: null,
  isDev: false,
  isSid: false,
  pay360Enabled: true,
  braintreeCardPaymentsEnabled: false,
  maintenanceMode: false,
  payPalEnabled: true,
  marketingConsentsEnabled: false,
  discountCodeEnabled: false,
  ucEnabled: false,
};

export const configSlice = createSlice({
  name: 'config',

  initialState,

  reducers: {
    initialise: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes

      const {
        apiAccessToken,
        baseURL,
        brand,
        enablePay360CardPayments,
        enableBraintreeCardPayments,
        payPalEnabled,
        environment,
        isDev,
        maintenanceMode,
        enableMarketingConsents,
        enableDiscountCode,
        enableUsercentrics,
      } = action.payload.config;

      state.apiAccessToken = apiAccessToken;
      state.baseURL = baseURL;
      state.brand = brand;
      state.environment = environment;
      state.isDev = isDev;
      state.pay360Enabled = enablePay360CardPayments;
      state.braintreeCardPaymentsEnabled = enableBraintreeCardPayments;
      state.payPalEnabled = payPalEnabled;
      state.maintenanceMode = maintenanceMode;
      state.marketingConsentsEnabled = enableMarketingConsents;
      state.discountCodeEnabled = enableDiscountCode;
      state.ucEnabled = enableUsercentrics;
    },
  },
});

export const selectConfig = (state) => state.config;

export default configSlice.reducer;
